// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"00f381cd","108":"e789b76a","174":"90a1ebc2","231":"3f693ff9","319":"1ec896ad","476":"218866e7","710":"8e84e4cd","794":"5c7fbbc1"}[chunkId] + ".chunk.js";
};